import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProfessionalAccessRoles } from '../services/clinicianManagmentPreCache';
import professionalAccessRolesFetchedAction from '../actions/professionalAccessRolesFetchedAction';

const useProfessionalAccessRoles = (
  professionalId,
  { enabled = true } = {},
) => {
  const dispatch = useDispatch();
  const professionalAccessFetchedFlag = useSelector(
    (state) => state.professionalAccessRolesFetched,
  );

  const fetchProfessionalAccessRoles = useCallback(async () => {
    try {
      dispatch(professionalAccessRolesFetchedAction('FETCHING'));
      const professionalAccess = await getProfessionalAccessRoles(
        professionalId,
      );
      if (professionalAccess) {
        dispatch(professionalAccessRolesFetchedAction('FETCHED'));
      } else {
        dispatch(professionalAccessRolesFetchedAction('NOFETCH'));
      }
      return professionalAccess;
    } catch (error) {
      dispatch(professionalAccessRolesFetchedAction('NONE'));
      console.error('Failed to fetch professionals:', error);
      return null;
    }
  }, [dispatch, professionalId]);

  useEffect(() => {
    if (!enabled) return;
    if (professionalAccessFetchedFlag === 'NONE') {
      fetchProfessionalAccessRoles(professionalId);
    }
  }, [
    enabled,
    professionalAccessFetchedFlag,
    fetchProfessionalAccessRoles,
  ]);
};

export default useProfessionalAccessRoles;
